export default __webpack_public_path__ + "static/media/business-presentation.9391e1cc.svg";